import { isWorkerEnvironment, Observable, ErrorSource, initXhrObservable, RequestType, initFetchObservable, computeStackTrace, toStackTraceString, noop, isServerError, isIntakeUrl, safeTruncate } from '@datadog/browser-core';
import { StatusType } from '../logger/isAuthorized';
export function startNetworkErrorCollection(configuration, lifeCycle) {
  if (!configuration.forwardErrorsToLogs) {
    return {
      stop: noop
    };
  } // XHR is not available in web workers, so we use an empty observable that never emits


  var xhrSubscription = (isWorkerEnvironment ? new Observable() : initXhrObservable(configuration)).subscribe(function (context) {
    if (context.state === 'complete') {
      handleResponse(RequestType.XHR, context);
    }
  });
  var fetchSubscription = initFetchObservable({
    responseBodyAction: function responseBodyAction(context) {
      return isNetworkError(context) ? 2
      /* ResponseBodyAction.COLLECT */
      : 0
      /* ResponseBodyAction.IGNORE */
      ;
    }
  }).subscribe(function (context) {
    if (context.state === 'resolve') {
      handleResponse(RequestType.FETCH, context);
    }
  });

  function isNetworkError(request) {
    return !isIntakeUrl(request.url) && (isRejected(request) || isServerError(request.status));
  }

  function handleResponse(type, request) {
    if (!isNetworkError(request)) {
      return;
    }

    var stack = 'error' in request && request.error ? toStackTraceString(computeStackTrace(request.error)) : request.responseBody || 'Failed to load';
    var domainContext = {
      isAborted: request.isAborted,
      handlingStack: request.handlingStack
    };
    lifeCycle.notify(0
    /* LifeCycleEventType.RAW_LOG_COLLECTED */
    , {
      rawLogsEvent: {
        message: "".concat(format(type), " error ").concat(request.method, " ").concat(request.url),
        date: request.startClocks.timeStamp,
        error: {
          stack: safeTruncate(stack, configuration.requestErrorResponseLengthLimit, '...'),
          // We don't know if the error was handled or not, so we set it to undefined
          handling: undefined
        },
        http: {
          method: request.method,
          // Cast resource method because of case mismatch cf issue RUMF-1152
          status_code: request.status,
          url: request.url
        },
        status: StatusType.error,
        origin: ErrorSource.NETWORK
      },
      domainContext: domainContext
    });
  }

  return {
    stop: function stop() {
      xhrSubscription.unsubscribe();
      fetchSubscription.unsubscribe();
    }
  };
}

function isRejected(request) {
  return request.status === 0 && request.responseType !== 'opaque';
}

function format(type) {
  if (RequestType.XHR === type) {
    return 'XHR';
  }

  return 'Fetch';
}